import { Reveal, SectionLabel } from "./Reveal";
import { STORE_EMAIL } from "../../data/catalog";

const rows = [
  { n: "01", t: "See the exact slab", d: "Real photos of every graded card we list. What you see in the listing is what lands on your doorstep — no stock images, no surprises." },
  { n: "02", t: "Tracked, every time", d: "Tracked UK shipping on every order, with worldwide delivery for collectors outside the UK." },
  { n: "03", t: "Protected checkout", d: "You buy through eBay, so every purchase is covered by the eBay Money Back Guarantee — backed by our 100% positive feedback." },
  { n: "04", t: "A real collector on the other end", d: `Questions about a card or combined postage? Email us at ${STORE_EMAIL} and we'll get back to you.` },
];

export const WhyUs = () => (
  <section id="why" className="mx-auto grid max-w-[1400px] gap-14 px-5 py-24 lg:grid-cols-12 lg:px-10 lg:py-36" data-testid="why-section">
    <div className="lg:col-span-5">
      <div className="lg:sticky lg:top-28">
        <Reveal>
          <SectionLabel n="03">Why InstantTCGZ</SectionLabel>
          <h2 className="font-display text-4xl font-black uppercase leading-[0.9] sm:text-6xl">Trust is<br />the <span className="text-volt">grade</span><br />that counts.</h2>
        </Reveal>
      </div>
    </div>
    <div className="lg:col-span-7">
      {rows.map((r, i) => (
        <Reveal key={r.n} delay={i * 0.05} className="why-row group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-9 sm:gap-10">
          <span className="font-display text-4xl font-black text-outline transition-colors duration-500 group-hover:text-volt sm:text-6xl">{r.n}</span>
          <div>
            <h3 className="font-display text-2xl font-bold sm:text-3xl">{r.t}</h3>
            <p className="mt-3 max-w-lg break-words text-base leading-relaxed text-slate-300">{r.d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
